module.exports = __webpack_public_path__ + "img/b.ac2ec900.jpg";